import { SimpleMetricsAggregator } from './simpleaggregator.js';

/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 */
class MetricsAggregator  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'MetricsAggregator';}

  /**
   * @inheritDoc
   */

   constructor() {
    this.name = MetricsAggregator.id;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    // Do nothing
  }

  /**
   * @inheritDoc
   */
   setup(client) {
    client.metricsAggregator = new SimpleMetricsAggregator(client);
  }
} MetricsAggregator.__initStatic();

export { MetricsAggregator };
//# sourceMappingURL=integration.js.map
